import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material';
import { NotificationProvider } from './context/NotificationContext';
import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import Layout from './components/Layout/Layout';
import Login from './pages/Login';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import InviteAccept from './pages/InviteAccept';
import Dashboard from './pages/Dashboard';
import Companies from './pages/Companies';
import Projects from './pages/Projects';
import GeneralTasks from './pages/GeneralTasks';
import Personnel from './pages/Personnel';
import DueDates from './pages/DueDates';
import CostSheets from './pages/CostSheets';
import WriteOffs from './pages/WriteOffs';
import DailyWorkInput from './pages/DailyWorkInput';
import DailyWorkCostSheetMapping from './pages/DailyWorkCostSheetMapping';
import WorkerHoursReport from './pages/WorkerHoursReport';
import MyHours from './pages/MyHours';
import Materials from './pages/Materials';
import SiteDelivery from './pages/SiteDelivery';
import SiteDeparture from './pages/SiteDeparture';
import WorkQuantities from './pages/WorkQuantities';
import ProjectExpenses from './pages/ProjectExpenses';
import ProjectTimelines from './pages/ProjectTimelines';
import Users from './pages/Users';
import Account from './pages/Account';
import FinanceDocuments, { FinanceHome } from './pages/FinanceDocuments';
import FinanceSettings from './pages/FinanceSettings';

const theme = createTheme({
  palette: {
    primary: {
      main: '#1976d2',
    },
    secondary: {
      main: '#dc004e',
    },
  },
});

function App() {
  return (
    <ThemeProvider theme={theme}>
      <NotificationProvider>
        <AuthProvider>
          <Router>
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/reset-password/:token" element={<ResetPassword />} />
              <Route path="/invite/:token" element={<InviteAccept />} />
              <Route
                path="/*"
                element={(
                  <ProtectedRoute>
                    <Layout>
                      <Routes>
                        <Route path="/" element={<Dashboard />} />
                        <Route path="/companies" element={<Companies />} />
                        <Route path="/projects" element={<Projects />} />
                        <Route path="/general-tasks" element={<GeneralTasks />} />
                        <Route path="/personnel" element={<Personnel />} />
                        <Route path="/due-dates" element={<DueDates />} />
                        <Route path="/tools" element={<Navigate to="/warehouse" replace />} />
                        <Route path="/materials" element={<Materials />} />
                        <Route path="/warehouse" element={<Materials />} />
                        <Route path="/site-delivery" element={<SiteDelivery />} />
                        <Route path="/site-departure" element={<SiteDeparture />} />
                        <Route path="/cost-sheets" element={<CostSheets />} />
                        <Route path="/daily-work-input" element={<DailyWorkInput />} />
                        <Route path="/daily-work-cost-sheet-mapping" element={<DailyWorkCostSheetMapping />} />
                        <Route path="/worker-hours-report" element={<WorkerHoursReport />} />
                        <Route path="/my-hours" element={<MyHours />} />
                        <Route path="/work-quantities" element={<WorkQuantities />} />
                        <Route path="/project-expenses" element={<ProjectExpenses />} />
                        <Route path="/project-timelines" element={<ProjectTimelines />} />
                        <Route path="/write-offs" element={<WriteOffs />} />
                        <Route path="/finance" element={<FinanceHome />} />
                        <Route path="/finance/quotes" element={<FinanceDocuments type="QUOTE" />} />
                        <Route path="/finance/deliveries" element={<FinanceDocuments type="DELIVERY_NOTE" />} />
                        <Route path="/finance/invoices" element={<FinanceDocuments type="INVOICE" />} />
                        <Route path="/finance/settings" element={<FinanceSettings />} />
                        <Route path="/users" element={<Users />} />
                        <Route path="/account" element={<Account />} />
                      </Routes>
                    </Layout>
                  </ProtectedRoute>
                )}
              />
            </Routes>
          </Router>
        </AuthProvider>
      </NotificationProvider>
    </ThemeProvider>
  );
}

export default App;
